import { FileUpload } from '../models/file-upload';
import { Logger } from '../models/logger';

export class ConvertOptionsV2Utils {

    public static hasProperty(fileUpload: FileUpload, property: string) {
        try {
            return !!fileUpload.options[property];
        } catch (e) {
            Logger.getLogger('ConvertOptionsUtils').trace7(`Could not find ${property} on FileUpload options`);
        }
    }

    public static getPropertyValue(fileUpload: FileUpload, property: string): string | undefined {
        try {
            return fileUpload.options[property];
        } catch (e) {
            Logger.getLogger('ConvertOptionsUtils').trace7(`Could not find ${property} on FileUpload options`);
        }
    }

    public static getSubPropertyValue(subpropertyValue: any, property: string) {
        try {
            return subpropertyValue[property];
        } catch (e) {
            Logger.getLogger('ConvertOptionsUtils').trace7(`Could not find property, ${property} on subproperty value`);
        }
    }

    public static hasPropertyWithValue(fileUpload: FileUpload, property: string, value: string) {
        try {
            const object = fileUpload.options[property];
            return object.formValue === value;
        } catch (e) {
            Logger.getLogger('ConvertOptionsUtils').trace7(`Could not find ${property} on FileUpload options`);
        }
    }
}
